module.exports = __webpack_public_path__ + "img/03.41a4894b.png";